import { module as Module } from "modujs";
import { whenReady } from "../utils/fonts";

import gsap from "gsap";
import { SplitText } from "gsap/all";
import { CUSTOM_EVENT, FONT } from "../config";
gsap.registerPlugin(SplitText);

export default class extends Module {
    constructor(m) {
        super(m);

        // Binding
        this.onResizeEndBind = this.onResizeEnd.bind(this);
        this.onFadeinTextProgressBind = this.onFadeinTextProgress.bind(this);

        // UI
        this.$el = this.el;
        this.$content = this.$("content")[0];

        // Data
        this.windowWidth = window.innerWidth;
        this.charsCount = 0;
        this.progress = 0;
        this.baseColor = getComputedStyle(this.$el).getPropertyValue('--base-color')
    }

    ///////////////
    // Lifecycle
    ///////////////
    init() {
        this.bindEvents();
        whenReady(FONT.EAGER).then((fonts) => this.onFontsLoaded(fonts));

        if(window.isReduceMotion) return
        // Init timelines
        this.timelineMain = gsap.timeline({ paused: true });
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener(CUSTOM_EVENT.RESIZE_END, this.onResizeEndBind);
        window.addEventListener("fadeinTextProgress", this.onFadeinTextProgressBind);
    }

    unbindEvents() {
        window.removeEventListener(CUSTOM_EVENT.RESIZE_END, this.onResizeEndBind);
        window.removeEventListener("fadeinTextProgress", this.onFadeinTextProgressBind);
    }

    ///////////////
    // Callbacks
    ///////////////
    onResizeEnd() {
        // If width has not changed, don't redo the split
        if (this.windowWidth == window.innerWidth || this.split.length == 0)
            return;

        // Store window width
        this.windowWidth = window.innerWidth;

        // Reset text as default
        this.split.revert();

        // Clear timelines
        this.timelineMain.clear();

        // Wait a frame to get split reverted
        requestAnimationFrame(() => {
            // Split again
            this.splitText();

            // Re-init GSAP timelines
            this.initMainTimeline();

            // Compute progress again
            this.computeProgress();
        });
    }

    onFontsLoaded(fonts) {
        if(window.isReduceMotion) return
        // Split
        this.splitText();

        requestAnimationFrame(() => {
            // Init timelines
            this.initMainTimeline();

            // Compute progress again
            this.computeProgress();
        });
    }

    onFadeinTextProgress(e) {
        const { target, progress } = e.detail;
        if (!this.el.contains(target) || !this.split) return;
        this.progress = progress;
        this.computeProgress();
    }

    ///////////////
    // Methods
    ///////////////
    initMainTimeline() {
        this.timelineMain.from(this.split.chars, {
            color: this.baseColor,
            stagger: 0.02,
        });
    }

    splitText() {
        this.split = new SplitText(this.$content, {
            type: "lines, words, chars",
            linesClass: "c-fadein-paragraph_line",
            wordsClass: "c-fadein-paragraph_word",
            charsClass: "c-fadein-paragraph_char c-split-text_char",
        });

        this.$content.querySelectorAll(".c-fadein-paragraph_line").forEach((line) => {
            line.style.display = "inline";
        });
        this.$content.querySelectorAll(".c-fadein-paragraph_word").forEach((word) => {
            word.style.display = "inline";
        });
        this.$content.querySelectorAll(".c-fadein-paragraph_char").forEach((char) => {
            char.style.display = "inline";
        });
    }

    computeProgress() {
        this.timelineMain?.progress?.(this.progress || 0);

        if (this.progress > 0) {
            if (this.$el.classList.contains('is-active')) return
            this.$el.classList.add('is-active')
        } else {
            if (!this.$el.classList.contains('is-active')) return
            this.$el.classList.remove('is-active')
        }
    }
}
